"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var AntdAddressSetForm_1 = __importDefault(require("../AntdAddressSetForm"));
var Cart = __importStar(require("../../Actions/Cart"));
var NavUrl_1 = __importStar(require("../../Utils/NavUrl"));
var Tracker_1 = __importDefault(require("../../Utils/Tracker"));
var CheckoutUtils = __importStar(require("./utils"));
var GenericInput_1 = require("./GenericInput");
var lodash_1 = __importDefault(require("lodash"));
var SectionPanel_1 = __importDefault(require("../../Templates/OrderPage/SectionPanel"));
var Config_1 = require("../../Config");
var TextUtil_1 = require("../../Utils/TextUtil");
function CheckoutForm(props, checkoutFormRef) {
  var _this = this;
  var _a = props.mobileApp,
    mobileApp = _a === void 0 ? false : _a,
    _b = props.disabled,
    disabled = _b === void 0 ? false : _b,
    _c = props.style,
    style = _c === void 0 ? {} : _c,
    _d = props.enableInvoiceFeature,
    enableInvoiceFeature = _d === void 0 ? false : _d,
    customLogisticsDisplay = props.customLogisticsDisplay,
    _e = props.forceSameAsBuyer,
    forceSameAsBuyer = _e === void 0 ? false : _e,
    _f = props.hideInvoiceDonationInput,
    hideInvoiceDonationInput = _f === void 0 ? false : _f,
    _g = props.disableAutoLogisticsSelection,
    disableAutoLogisticsSelection = _g === void 0 ? false : _g,
    renderCustomPaymentForm = props.renderCustomPaymentForm,
    renderCustomLogisticsForm = props.renderCustomLogisticsForm,
    renderCustomOthersForm = props.renderCustomOthersForm,
    renderInvoiceDonationInfo = props.renderInvoiceDonationInfo,
    remapPaymentSubTypeOpts = props.remapPaymentSubTypeOpts;
  // outlet
  var cart = reconnect_js_1.useOutlet('cart')[0];
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  var isCartLoaded = react_1.useRef(false);
  // local state
  var form = antd_1.Form.useForm()[0];
  var _h = react_1.useState(CheckoutUtils.cartInitialData),
    values = _h[0],
    setValues = _h[1];
  var _j = react_1.useState(CheckoutUtils.cvsInitialData),
    cvs = _j[0],
    setCvs = _j[1];
  var _k = react_1.useState(forceSameAsBuyer || false),
    isSameAsBuyer = _k[0],
    setIsSameAsBuyer = _k[1];
  var _l = react_1.useState([]),
    paymentSubTypeOptions = _l[0],
    setPaymentSubTypeOptions = _l[1];
  var _m = react_1.useState([]),
    logisticsTypeOptions = _m[0],
    setLogisticsTypeOptions = _m[1];
  var _o = react_1.useState([]),
    logisticsSubTypeOptions = _o[0],
    setLogisticsSubTypeOptions = _o[1];
  var _p = react_1.useState([]),
    invoiceCategoryOptions = _p[0],
    setInvoiceCategoryOptions = _p[1];
  var _q = react_1.useState([]),
    invoiceCarrierOptions = _q[0],
    setInvoiceCarrierOptions = _q[1];
  var _r = react_1.useState(null),
    logisticsSubTypeOptionsSet = _r[0],
    setLogisticsSubTypeOptionsSet = _r[1];
  var _s = react_1.useState([]),
    invoiceTypeOptions = _s[0],
    setInvoiceTypeOptions = _s[1];
  if (checkoutFormRef) {
    checkoutFormRef.current = {
      submit: function submit() {
        form.submit();
      }
    };
  }
  var restoreTempDataFromStorage = react_1.useCallback(function () {
    return __awaiter(_this, void 0, void 0, function () {
      var partialCart;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, CheckoutUtils.getAndClearTempDataFromStorage()];
          case 1:
            partialCart = _a.sent();
            if (!partialCart) {
              return [2 /*return*/];
            }

            form.setFieldsValue(partialCart);
            setValues(function (prev) {
              return __assign(__assign({}, prev), partialCart);
            });
            return [2 /*return*/];
        }
      });
    });
  }, [form]);
  react_1.useEffect(function () {
    var onLoaded = function onLoaded() {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, updateConfig, checkoutFormSpec, nextConfig, err_1, _b, paymentSubTypeOpts, logisticsTypeOpts, logisticSubTypeOptsSet, logisticSubTypeOpts, invoiceCategoryOpts, invoiceCarrierTypeOpts, invoiceTypeOpts;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              // to call project level app actions on cart loaded
              if (cart.items.length <= 0 || isCartLoaded.current) {
                return [2 /*return*/];
              }

              isCartLoaded.current = true;
              _a = AppActions.onCartLoaded(cart), updateConfig = _a.updateConfig, checkoutFormSpec = _a.checkoutFormSpec;
              nextConfig = updateConfig || cart;
              if (!!lodash_1.default.isEqual(nextConfig, cart)) return [3 /*break*/, 4];
              _c.label = 1;
            case 1:
              _c.trys.push([1, 3,, 4]);
              return [4 /*yield*/, Cart.editConfig(updateConfig)];
            case 2:
              _c.sent();
              return [3 /*break*/, 4];
            case 3:
              err_1 = _c.sent();
              console.error('CheckoutForm onLoaded editConfig Error: ', err_1);
              return [3 /*break*/, 4];
            case 4:
              console.log('dbg', nextConfig);
              form.setFieldsValue(nextConfig);
              setValues(function (prev) {
                return __assign(__assign({}, prev), nextConfig);
              });
              setCvs(function (prev) {
                return __assign(__assign({}, prev), CheckoutUtils.getCvs(nextConfig.extra_data));
              });
              _b = CheckoutUtils.formatCheckoutFormSpecToAntdOptions(checkoutFormSpec, nextConfig, {
                customLogisticsDisplay: customLogisticsDisplay,
                remapPaymentSubTypeOpts: remapPaymentSubTypeOpts
              }), paymentSubTypeOpts = _b.paymentSubTypeOpts, logisticsTypeOpts = _b.logisticsTypeOpts, logisticSubTypeOptsSet = _b.logisticSubTypeOptsSet, logisticSubTypeOpts = _b.logisticSubTypeOpts, invoiceCategoryOpts = _b.invoiceCategoryOpts, invoiceCarrierTypeOpts = _b.invoiceCarrierTypeOpts, invoiceTypeOpts = _b.invoiceTypeOpts;
              restoreTempDataFromStorage();
              setPaymentSubTypeOptions(paymentSubTypeOpts);
              setLogisticsTypeOptions(logisticsTypeOpts);
              setLogisticsSubTypeOptions(logisticSubTypeOpts);
              setLogisticsSubTypeOptionsSet(logisticSubTypeOptsSet);
              setInvoiceCategoryOptions(invoiceCategoryOpts);
              setInvoiceCarrierOptions(invoiceCarrierTypeOpts);
              setInvoiceTypeOptions(invoiceTypeOpts);
              return [2 /*return*/];
          }
        });
      });
    };

    onLoaded();
  }, [AppActions, cart, disabled, form, restoreTempDataFromStorage, customLogisticsDisplay, remapPaymentSubTypeOpts]);
  react_1.useEffect(function () {
    if (isSameAsBuyer) {
      form.setFieldsValue({
        receiver_name: form.getFieldValue('buyer_name'),
        receiver_phone: form.getFieldValue('buyer_phone'),
        receiver_email: form.getFieldValue('buyer_email'),
        receiver_tel: form.getFieldValue('buyer_tel'),
        receiver_tel_ext: form.getFieldValue('buyer_tel_ext'),
        receiver_zip: form.getFieldValue('buyer_zip'),
        receiver_city: form.getFieldValue('buyer_city'),
        receiver_district: form.getFieldValue('buyer_district'),
        receiver_address: form.getFieldValue('buyer_address')
      });
    }
  }, [cart, form, isSameAsBuyer]);
  var onCalculateFreight = react_1.useCallback(function (_a) {
    var logisticsType = _a.logisticsType,
      logisticsSubtype = _a.logisticsSubtype;
    return __awaiter(_this, void 0, void 0, function () {
      var e_1;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2, 3, 4]);
            AppActions.setLoading(true);
            return [4 /*yield*/, Cart.editConfig(__assign(__assign({}, cart), {
              extra_data: __assign({}, CheckoutUtils.cvsInitialData),
              logistics_cvs_store_id: '',
              logistics_type: logisticsType,
              logistics_subtype: logisticsSubtype
            }))];
          case 1:
            _b.sent();
            return [3 /*break*/, 4];
          case 2:
            e_1 = _b.sent();
            console.warn(e_1);
            return [3 /*break*/, 4];
          case 3:
            AppActions.setLoading(false);
            return [7 /*endfinally*/];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }, [AppActions, cart]);
  var getInvoiceCarrierNumberRules = function getInvoiceCarrierNumberRules(invoiceCarrierType) {
    if (invoiceCarrierType === Cart.INVOICE_CARRIER_TYPE.cdc) {
      return [{
        pattern: /^[A-Z]{2}[0-9]{14}$/g,
        message: '自然人憑證條碼載具格式不正確'
      }];
    } else if (invoiceCarrierType === Cart.INVOICE_CARRIER_TYPE.mobile) {
      return [{
        pattern: /^\/[0-9A-Z+-.]{7}$/g,
        message: '手機條碼載具格式不正確'
      }];
    } else {
      return [];
    }
  };
  var getInputProps = react_1.useCallback(function (field) {
    var defaultTextInputProps = {
      name: field,
      value: form.getFieldValue(field),
      disabled: disabled,
      onChange: function onChange(e) {
        var _a;
        form.setFieldsValue((_a = {}, _a[field] = e.target.value, _a));
      },
      type: GenericInput_1.INPUT_TYPES.text
    };
    var defaultSelectInputProps = __assign(__assign({}, defaultTextInputProps), {
      onChange: function onChange(value) {
        var _a;
        form.setFieldsValue((_a = {}, _a[field] = value, _a));
      },
      type: GenericInput_1.INPUT_TYPES.select
    });
    return {
      payment_subtype: {
        label: '付款方式',
        rules: [{
          required: true,
          message: '付款方式為必填值'
        }],
        placeholder: '請選擇付款方式',
        options: paymentSubTypeOptions,
        name: field,
        value: form.getFieldValue(field),
        disabled: disabled,
        onChange: function onChange(value) {
          return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c;
            var _d, _e, _f, _g;
            return __generator(this, function (_h) {
              switch (_h.label) {
                case 0:
                  if (disableAutoLogisticsSelection) {
                    form.setFieldsValue((_a = {}, _a[field] = value, _a));
                    return [2 /*return*/];
                  }

                  if (!(value === Cart.PAYMENT_SUBTYPE.cod)) return [3 /*break*/, 2];
                  form.setFieldsValue((_b = {}, _b[field] = value, _b.logistics_type = Cart.LOGISTICS_TYPE.cvs, _b.logistics_subtype = (_e = (_d = logisticsSubTypeOptionsSet[Cart.LOGISTICS_TYPE.cvs]) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.value, _b));
                  return [4 /*yield*/, onCalculateFreight({
                    logisticsType: Cart.LOGISTICS_TYPE.cvs,
                    logisticsSubtype: (_g = (_f = logisticsSubTypeOptionsSet[Cart.LOGISTICS_TYPE.cvs]) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.value
                  })];
                case 1:
                  _h.sent();
                  setLogisticsSubTypeOptions(logisticsSubTypeOptionsSet[Cart.LOGISTICS_TYPE.cvs]);
                  setCvs(CheckoutUtils.cvsInitialData);
                  return [3 /*break*/, 3];
                case 2:
                  form.setFieldsValue((_c = {}, _c[field] = value, _c));
                  _h.label = 3;
                case 3:
                  return [2 /*return*/];
              }
            });
          });
        },

        type: GenericInput_1.INPUT_TYPES.select
      },
      logistics_type: __assign(__assign({}, defaultSelectInputProps), {
        label: '物流方式',
        rules: [{
          required: true,
          message: '物流方式為必填值'
        }],
        onChange: function onChange(value) {
          return __awaiter(_this, void 0, void 0, function () {
            var logiSubTypeOptions, firstLogiSubTypeOptionValue;
            var _a;
            var _b;
            return __generator(this, function (_c) {
              switch (_c.label) {
                case 0:
                  logiSubTypeOptions = logisticsSubTypeOptionsSet[value] || [];
                  firstLogiSubTypeOptionValue = ((_b = logiSubTypeOptions[0]) === null || _b === void 0 ? void 0 : _b.value) || '';
                  form.setFieldsValue((_a = {}, _a[field] = value, _a.logistics_subtype = firstLogiSubTypeOptionValue, _a));
                  return [4 /*yield*/, onCalculateFreight({
                    logisticsType: value,
                    logisticsSubtype: firstLogiSubTypeOptionValue
                  })];
                case 1:
                  _c.sent();
                  setLogisticsSubTypeOptions(logiSubTypeOptions);
                  setCvs(CheckoutUtils.cvsInitialData);
                  return [2 /*return*/];
              }
            });
          });
        },

        options: !disableAutoLogisticsSelection && form.getFieldValue('payment_subtype') === Cart.PAYMENT_SUBTYPE.cod ? logisticsTypeOptions.filter(function (opt) {
          return opt.value === Cart.LOGISTICS_TYPE.cvs;
        }) : logisticsTypeOptions,
        placeholder: '請選擇物流方式'
      }),
      logistics_subtype: __assign(__assign({}, defaultSelectInputProps), {
        label: '選擇物流商',
        rules: [{
          required: true,
          message: '物流商為必填值'
        }],
        onChange: function onChange(value) {
          return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  form.setFieldsValue((_a = {}, _a[field] = value, _a));
                  return [4 /*yield*/, onCalculateFreight({
                    logisticsType: form.getFieldValue('logistics_type'),
                    logisticsSubtype: value
                  })];
                case 1:
                  _b.sent();
                  setCvs(CheckoutUtils.cvsInitialData);
                  return [2 /*return*/];
              }
            });
          });
        },

        options: logisticsSubTypeOptions,
        placeholder: '請選擇物流商'
      }),
      buyer_name: __assign(__assign({}, defaultTextInputProps), {
        label: '姓名',
        rules: [{
          required: true,
          message: '姓名為必填值，中文2-5個字，英文4-10個字'
        }],
        placeholder: '請輸入姓名'
      }),
      buyer_phone: __assign(__assign({}, defaultTextInputProps), {
        label: '行動電話',
        rules: [{
          required: true,
          message: '行動電話為必填值，需為台灣手機(09開頭)或是帶國碼的完整手機號碼(用+開頭)'
        }, {
          pattern: /^(09[0-9]{8}|\+[1-9]{1}[0-9]{7,11})$/,
          message: '需為台灣手機(09開頭)或是帶國碼的完整手機號碼(用+開頭)'
        }],
        placeholder: '請輸入行動電話'
      }),
      buyer_email: __assign(__assign({}, defaultTextInputProps), {
        label: '電子郵件',
        rules: [{
          required: true,
          message: '電子郵件為必填值'
        }, {
          pattern: /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/,
          message: '需為合法電子郵件'
        }],
        placeholder: '請輸入電子郵件'
      }),
      buyer_tel: __assign(__assign({}, defaultTextInputProps), {
        label: '市話',
        rules: [],
        placeholder: '請輸入市話'
      }),
      buyer_tel_ext: __assign(__assign({}, defaultTextInputProps), {
        label: '市話分機',
        rules: [],
        placeholder: '請輸入市話分機'
      }),
      receiver_name: __assign(__assign({}, defaultTextInputProps), {
        label: '姓名',
        rules: [{
          required: !isSameAsBuyer,
          message: '姓名為必填值，中文2-5個字，英文4-10個字'
        }],
        disabled: disabled || isSameAsBuyer,
        placeholder: '請輸入姓名'
      }),
      receiver_phone: __assign(__assign({}, defaultTextInputProps), {
        label: '行動電話',
        rules: [{
          required: !isSameAsBuyer,
          message: '行動電話為必填值，開頭為 09，共10碼'
        }, {
          len: 10,
          message: '行動電話需為 10 碼'
        }],
        maxLength: 10,
        disabled: disabled || isSameAsBuyer,
        placeholder: '請輸入行動電話'
      }),
      receiver_email: __assign(__assign({}, defaultTextInputProps), {
        label: '電子郵件',
        rules: [{
          required: !isSameAsBuyer,
          message: '電子郵件為必填值'
        }, {
          pattern: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
          message: '需為合法電子郵件'
        }],
        disabled: disabled || isSameAsBuyer,
        placeholder: '請輸入電子郵件'
      }),
      receiver_tel: __assign(__assign({}, defaultTextInputProps), {
        label: '市話',
        rules: [],
        disabled: disabled || isSameAsBuyer,
        placeholder: '請輸入市話'
      }),
      receiver_tel_ext: __assign(__assign({}, defaultTextInputProps), {
        label: '市話分機',
        rules: [],
        disabled: disabled || isSameAsBuyer,
        placeholder: '請輸入市話分機'
      }),
      order_note: __assign(__assign({}, defaultTextInputProps), {
        label: '備註',
        rules: [],
        type: GenericInput_1.INPUT_TYPES.textArea,
        placeholder: '請輸入備註'
      }),
      invoice_category: __assign(__assign({}, defaultSelectInputProps), {
        label: '發票種類',
        rules: [{
          required: true,
          message: '發票種類為必填'
        }],
        options: invoiceCategoryOptions,
        placeholder: '請選擇發票種類'
      }),
      invoice_uni_no: __assign(__assign({}, defaultTextInputProps), {
        label: '統一編號',
        rules: [{
          required: true,
          message: '統一編號為必填'
        }, {
          message: '統一編號須為剛好 8 位數字',
          pattern: /^\d{8}$/
        }],
        maxLength: 8,
        placeholder: '請輸入統一編號'
      }),
      invoice_donation: __assign(__assign({}, defaultSelectInputProps), {
        label: '是否捐贈發票',
        rules: [{
          required: true,
          message: '是否捐贈發票為必填'
        }],
        onChange: function onChange(value) {
          return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
              if (value === Cart.INVOICE_DONATION.t) {
                form.setFieldsValue({
                  invoice_carrier_type: Cart.INVOICE_CARRIER_TYPE.none
                });
                setValues(function (prev) {
                  return __assign(__assign({}, prev), {
                    invoice_carrier_type: Cart.INVOICE_CARRIER_TYPE.none
                  });
                });
              } else {
                form.setFieldsValue({
                  invoice_carrier_type: ''
                });
                setValues(function (prev) {
                  return __assign(__assign({}, prev), {
                    invoice_carrier_type: ''
                  });
                });
              }
              form.setFieldsValue((_a = {}, _a[field] = value, _a));
              return [2 /*return*/];
            });
          });
        },

        options: Object.values(Cart.INVOICE_DONATION).map(function (v) {
          return Cart.INVOICE_DONATION_DISPLAY[v];
        }),
        placeholder: '請選擇是否捐贈發票'
      }),
      invoice_love_code: __assign(__assign({}, defaultTextInputProps), {
        label: '愛心捐贈碼',
        rules: [{
          required: true,
          message: '愛心捐贈碼為必填'
        }, {
          message: '愛心捐贈碼須為 3 ~ 7 位數數字',
          pattern: /^\d{3,7}$/
        }],
        maxLength: 7,
        placeholder: '請輸入愛心捐贈碼'
      }),
      invoice_carrier_type: __assign(__assign({}, defaultSelectInputProps), {
        label: '載具類型',
        rules: [{
          required: true,
          message: '載具類型為必填'
        }],
        disabled: form.getFieldValue('invoice_donation') === Cart.INVOICE_DONATION.t || disabled,
        options: form.getFieldValue('invoice_donation') === Cart.INVOICE_DONATION.f ? invoiceCarrierOptions.map(function (opt) {
          if (opt.value === Cart.INVOICE_CARRIER_TYPE.none) {
            return __assign(__assign({}, opt), {
              disabled: true
            });
          } else {
            return opt;
          }
        }) : invoiceCarrierOptions,
        placeholder: '請選擇載具類型'
      }),
      invoice_carrier_num: __assign(__assign({}, defaultTextInputProps), {
        label: '載具條碼',
        rules: __spreadArray([{
          required: true,
          message: '載具條碼為必填'
        }], getInvoiceCarrierNumberRules(form.getFieldValue('invoice_carrier_type'))),
        placeholder: '請輸入載具條碼'
      }),
      // v2
      invoice_type: __assign(__assign({}, defaultSelectInputProps), {
        label: '發票種類',
        rules: [{
          required: true,
          message: '發票種類為必填'
        }],
        options: invoiceTypeOptions,
        placeholder: '請選擇發票種類'
      }),
      b2c_donate_code: __assign(__assign({}, defaultTextInputProps), {
        label: '愛心捐贈碼',
        rules: [{
          required: true,
          message: '愛心捐贈碼為必填'
        }, {
          message: '愛心捐贈碼須為 3 - 7 位數字',
          pattern: /^\d{3,7}$/
        }],
        maxLength: 7,
        placeholder: '請輸入愛心捐贈碼'
      }),
      b2c_phone_carrier_code: __assign(__assign({}, defaultTextInputProps), {
        label: '手機載具',
        rules: [{
          required: true,
          message: '手機載具為必填'
        }, {
          message: '手機載具格式不正確，須為斜線(/)加上7碼數字或大寫字母',
          pattern: /^\/[0-9A-Z+-.]{7}$/g
        }],
        placeholder: '請輸入手機載具'
      }),
      b2c_npc_code: __assign(__assign({}, defaultTextInputProps), {
        label: '自然人憑證條碼',
        rules: [{
          required: true,
          message: '自然人憑證條碼為必填'
        }, {
          message: '自然人憑證條碼不正確，須為前2碼英文大寫，加上14碼數字',
          pattern: /^[A-Z]{2}[0-9]{14}$/g
        }],
        placeholder: '請輸入自然人憑證條碼'
      }),
      b2b_company_name: __assign(__assign({}, defaultTextInputProps), {
        label: '公司名稱',
        rules: [{
          required: true,
          message: '公司名稱為必填'
        }],
        placeholder: '請輸入公司名稱'
      }),
      b2b_company_no: __assign(__assign({}, defaultTextInputProps), {
        label: '統一編號',
        rules: [{
          required: true,
          message: '統一編號為必填'
        }, {
          message: '統一編號須為剛好 8 位數字',
          pattern: /^\d{8}$/
        }],
        maxLength: 8,
        placeholder: '請輸入統一編號'
      })
    }[field];
  }, [form, disabled, isSameAsBuyer, paymentSubTypeOptions, logisticsTypeOptions, logisticsSubTypeOptions, logisticsSubTypeOptionsSet, onCalculateFreight, invoiceCarrierOptions, invoiceCategoryOptions, invoiceTypeOptions]);
  var onFinish = function onFinish(data) {
    return __awaiter(_this, void 0, void 0, function () {
      var withoutCvsSelect, overridePayload, payload, ex_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3, 4, 5]);
            withoutCvsSelect = data.logistics_type === Cart.LOGISTICS_TYPE.cvs && !cvs.CVSStoreID;
            if (withoutCvsSelect) {
              form.scrollToField('logistics_subtype', {
                behavior: function behavior(e) {
                  var _a = e[0],
                    el = _a.el,
                    top = _a.top;
                  el.scrollTo({
                    left: 0,
                    top: top - 100,
                    behavior: 'smooth'
                  });
                }
              });
              antd_1.message.error('請選擇寄送超商');
              return [2 /*return*/];
            }

            if (!TextUtil_1.validateTextLength({
              ascii: {
                min: 4,
                max: 10
              },
              unicode: {
                min: 2,
                max: 5
              }
            }, data.buyer_name)) {
              alert('buyer_name英文為4-10字元, 中文為2-5');
              return [2 /*return*/];
            }

            AppActions.setLoading(true);
            overridePayload = isSameAsBuyer ? {
              receiver_name: data.buyer_name,
              receiver_phone: data.buyer_phone,
              receiver_email: data.buyer_email,
              receiver_zip: data.buyer_zip,
              receiver_city: data.buyer_city,
              receiver_district: data.buyer_district,
              receiver_address: data.buyer_address,
              receiver_tel: data.buyer_tel,
              receiver_tel_ext: data.buyer_tel_ext
            } : {};
            payload = __assign(__assign(__assign({}, data), {
              logistics_cvs_store_id: cvs.CVSStoreID,
              extra_data: __assign(__assign({}, form.getFieldValue('extra_data') || {}), cvs)
            }), overridePayload);
            return [4 /*yield*/, Cart.editConfig(payload)];
          case 1:
            _a.sent();
            return [4 /*yield*/, AppActions.navigate(mobileApp ? NavUrl_1.default.from(NavUrl_1.PredefinedRoute.mobileCheckoutReview) : NavUrl_1.default.from(NavUrl_1.PredefinedRoute.checkoutReview))];
          case 2:
            _a.sent();
            Tracker_1.default.addCheckoutInfo({
              cart: __assign(__assign({}, cart), payload)
            });
            return [3 /*break*/, 5];
          case 3:
            ex_1 = _a.sent();
            console.warn('[CheckoutForm.onFinish]', ex_1);
            return [3 /*break*/, 5];
          case 4:
            AppActions.setLoading(false);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };

  var onError = function onError(error) {
    console.log('debug', error);
  };
  var onSelectCVS = function onSelectCVS() {
    return __awaiter(_this, void 0, void 0, function () {
      var values_1, e_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 5,, 6]);
            //INFO : partial validate for below 3 fields
            AppActions.setLoading(true);
            return [4 /*yield*/, form.validateFields(['payment_subtype', 'logistics_type', 'logistics_subtype'])];
          case 1:
            _a.sent();
            values_1 = form.getFieldsValue();
            return [4 /*yield*/, Cart.editConfig(__assign(__assign({}, cart), {
              extra_data: __assign({}, CheckoutUtils.cvsInitialData),
              logistics_cvs_store_id: '',
              payment_subtype: values_1.payment_subtype,
              logistics_type: values_1.logistics_type,
              logistics_subtype: values_1.logistics_subtype
            }))];
          case 2:
            _a.sent();
            return [4 /*yield*/, CheckoutUtils.setTempDataToStorage(values_1)];
          case 3:
            _a.sent();
            return [4 /*yield*/, Cart.onSelectCVS(values_1.logistics_subtype)];
          case 4:
            _a.sent();
            return [3 /*break*/, 6];
          case 5:
            e_2 = _a.sent();
            console.log('debug', e_2);
            return [3 /*break*/, 6];
          case 6:
            return [2 /*return*/];
        }
      });
    });
  };

  return react_1.default.createElement(Wrapper, {
    style: style,
    className: "rev-CheckoutForm"
  }, react_1.default.createElement(antd_1.Form, {
    form: form,
    onFinish: onFinish,
    onFinishFailed: onError,
    onValuesChange: function onValuesChange(data) {
      Object.entries(data).forEach(function (f) {
        setValues(function (prev) {
          var _a;
          return __assign(__assign({}, prev), (_a = {}, _a[f[0]] = f[1], _a));
        });
      });
    },
    scrollToFirstError: {
      behavior: function behavior(e) {
        var _a = e[0],
          el = _a.el,
          top = _a.top;
        el.scrollTo({
          left: 0,
          top: top - 100,
          behavior: 'smooth'
        });
      }
    },
    initialValues: cart
  }, react_1.default.createElement(SectionPanel_1.default, {
    header: AppActions.L('payment_logistics_section_title'),
    key: 1
  }, react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('payment_subtype'))), renderCustomPaymentForm && renderCustomPaymentForm({
    disabled: disabled,
    payment_subtype: form.getFieldValue('payment_subtype'),
    getExtraData: function getExtraData() {
      return form.getFieldValue('extra_data');
    },
    setExtraData: function setExtraData(nextExtraData) {
      form.setFieldsValue({
        extra_data: nextExtraData
      });
    }
  }), react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('logistics_type'))), [Cart.LOGISTICS_TYPE.self_pick, Cart.LOGISTICS_TYPE.custom].indexOf(form.getFieldValue('logistics_type')) === -1 && (logisticsSubTypeOptions || []).length !== 0 && react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('logistics_subtype'))), [Cart.LOGISTICS_TYPE.custom, Cart.LOGISTICS_TYPE.oversea, Cart.LOGISTICS_TYPE.self_pick].indexOf(form.getFieldValue('logistics_type')) > -1 && renderCustomLogisticsForm && renderCustomLogisticsForm({
    logistics_type: form.getFieldValue('logistics_type'),
    logistics_subtype: form.getFieldValue('logistics_subtype'),
    disabled: disabled,
    getExtraData: function getExtraData() {
      return form.getFieldValue('extra_data');
    },
    setExtraData: function setExtraData(nextExtraData) {
      form.setFieldsValue({
        extra_data: nextExtraData
      });
    }
  }) || null, form.getFieldValue('logistics_type') === Cart.LOGISTICS_TYPE.cvs && react_1.default.createElement(antd_1.Card, {
    style: {
      width: '100%'
    },
    actions: [react_1.default.createElement(antd_1.Button, {
      disabled: disabled,
      onClick: onSelectCVS
    }, "\u9078\u64C7\u8D85\u5546")]
  }, !!cvs.CVSStoreID ? react_1.default.createElement(antd_1.Card.Meta, {
    avatar: react_1.default.createElement(antd_1.Avatar, {
      shape: "square",
      src: Cart.CVS_ICON[form.getFieldValue('logistics_subtype')]
    }),
    title: cvs.CVSStoreName,
    description: cvs.CVSAddress
  }) : react_1.default.createElement(antd_1.Empty, null))), react_1.default.createElement(SectionPanel_1.default, {
    header: forceSameAsBuyer && form.getFieldValue('logistics_type') !== Cart.LOGISTICS_TYPE.oversea ? AppActions.L('receiver_info') : AppActions.L('buyer_info'),
    key: 2
  }, react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('buyer_name'))), react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('buyer_phone'))), react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('buyer_email'))), react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('buyer_tel'))), react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('buyer_tel_ext'))), [Cart.LOGISTICS_TYPE.self_pick, Cart.LOGISTICS_TYPE.custom, Cart.LOGISTICS_TYPE.oversea].indexOf(form.getFieldValue('logistics_type')) === -1 && react_1.default.createElement(AntdAddressSetForm_1.default, {
    isRequired: form.getFieldValue('logistics_type') === Cart.LOGISTICS_TYPE.home,
    isReadOnly: disabled,
    name: "buyer",
    form: form
  })), !forceSameAsBuyer && react_1.default.createElement(SectionPanel_1.default, {
    header: AppActions.L('receiver_info'),
    key: 4,
    subHeader: !disabled ? react_1.default.createElement("div", {
      style: {
        display: 'flex'
      }
    }, react_1.default.createElement(antd_1.Checkbox, {
      checked: isSameAsBuyer,
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      onChange: function onChange(e) {
        setIsSameAsBuyer(e.target.checked);
      }
    }), react_1.default.createElement("div", {
      style: {
        paddingLeft: 10
      },
      onClick: function onClick(e) {
        e.stopPropagation();
        setIsSameAsBuyer(function (prev) {
          return !prev;
        });
      }
    }, "\u540C\u8CB7\u5BB6")) : null
  }, react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('receiver_name'))), react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('receiver_phone'))), react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('receiver_email'))), react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('receiver_tel'))), react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('receiver_tel_ext'))), values.logistics_type === Cart.LOGISTICS_TYPE.home && react_1.default.createElement(AntdAddressSetForm_1.default, {
    name: "receiver",
    form: form,
    isReadOnly: disabled || isSameAsBuyer,
    isRequired: !isSameAsBuyer && form.getFieldValue('logistics_type') === Cart.LOGISTICS_TYPE.home
  })), !enableInvoiceFeature ? null : Config_1.get().fastelVersion.indexOf('v2') > -1 ? react_1.default.createElement(SectionPanel_1.default, {
    header: "\u767C\u7968\u8CC7\u8A0A",
    key: 6
  }, react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('invoice_type'))), values.invoice_type === Cart.INVOICE_TYPE.B2C_DONATE && !hideInvoiceDonationInput && react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('b2c_donate_code'))), values.invoice_type === Cart.INVOICE_TYPE.B2C_DONATE && typeof renderInvoiceDonationInfo === 'function' && renderInvoiceDonationInfo({}), values.invoice_type === Cart.INVOICE_TYPE.B2C_PHONE_CARRIER && react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('b2c_phone_carrier_code'))), values.invoice_type === Cart.INVOICE_TYPE.B2C_NPC && react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('b2c_npc_code'))), values.invoice_type === Cart.INVOICE_TYPE.B2B && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('b2b_company_name'))), react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('b2b_company_no'))))) : react_1.default.createElement(SectionPanel_1.default, {
    header: "\u767C\u7968\u8CC7\u8A0A",
    key: 6
  }, react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('invoice_category'))), values.invoice_category === Cart.INVOICE_CATEGORY.b2b && react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('invoice_uni_no'))), values.invoice_category === Cart.INVOICE_CATEGORY.b2c && react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('invoice_donation'))), values.invoice_donation === Cart.INVOICE_DONATION.t && react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('invoice_love_code'))), react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('invoice_carrier_type'))), (values.invoice_carrier_type === Cart.INVOICE_CARRIER_TYPE.cdc || values.invoice_carrier_type === Cart.INVOICE_CARRIER_TYPE.mobile) && react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('invoice_carrier_num'))))), react_1.default.createElement(SectionPanel_1.default, {
    header: "\u5176\u4ED6\u8CC7\u8A0A",
    key: 7
  }, renderCustomOthersForm && renderCustomOthersForm({
    disabled: disabled,
    getExtraData: function getExtraData() {
      return form.getFieldValue('extra_data');
    },
    setExtraData: function setExtraData(nextExtraData) {
      form.setFieldsValue({
        extra_data: nextExtraData
      });
    }
  }), react_1.default.createElement(GenericInput_1.GenericInput, __assign({}, getInputProps('order_note'))))));
}
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.default = react_1.default.forwardRef(CheckoutForm);
var templateObject_1;